import { useEffect } from 'react';

export type HeaderCellWidthProps = {
  isResizingColumn: undefined | null | string;
  columnWidths: any;
};

export const useSetHeaderCellWidth = (columnHeader: HeaderCellWidthProps, tableName: string | undefined) => {
  const storageTableName = tableName ?? 'bulkQuotesChildTable';

  useEffect(() => {
    if (columnHeader?.isResizingColumn !== undefined && columnHeader?.isResizingColumn !== null) {
      localStorage.setItem(
        `${storageTableName}-width-${columnHeader.isResizingColumn}`,
        columnHeader.columnWidths[columnHeader.isResizingColumn]
      );
    }
  }, [columnHeader, storageTableName]);
};
